import sidebar from './modules/sidebar';
import translations from './modules/translations';
import feature_toggles from './modules/feature_toggles';
import themes from './modules/themes';
import current from './modules/current';

export default {
  modules: {
    current,
    sidebar,
    translations,
    feature_toggles,
    themes,
  },
};
